import {memo} from "react";
import {Chip} from "@material-tailwind/react";
import {useTranslation} from "react-i18next";

interface StatusLabelProps {
    status: string
}

const StatusLabel = ({status}: StatusLabelProps) => {
    const {t} = useTranslation();
    return <Chip className="w-fit inline-block" value={t(status)} color={status === 'Active' ? 'teal' : 'red'}/>;
}

export default memo(StatusLabel);
